import { Tab, TabPanel, TabPanels, Tabs, TabsList } from '@octano/global-ui';
import { useContext, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import { courseToFormFields } from '../adapter/adapterResponseDetails';
import { CourseFormContext } from '../provider/CourseProvider';
import { CourseFormFields } from '../types/details';

import CourseFooterSection from './sections/CourseFooterSection';
import CourseHeaderSection from './sections/CourseHeaderSection';
import CourseAdministrativeTab from './tabs/CourseAdministrativeTab';
import CourseTeachingTab from './tabs/CourseTeachingTab';

type CourseFormProps = {
  onBack?: () => void;
};

const CourseForm = ({ onBack }: CourseFormProps) => {
  const { t } = useTranslation(TranslationsKeys.COURSES_DETAILS);
  const { course, formData } = useContext(CourseFormContext);

  const methodsAdmin = useForm<CourseFormFields>();
  const methodsTeaching = useForm<CourseFormFields>();

  useEffect(() => {
    if (course && formData) {
      const values = courseToFormFields(course, formData);
      methodsAdmin.reset(values);
      methodsTeaching.reset(values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course, formData]);

  return (
    <>
      <CourseHeaderSection onBack={onBack} />
      <Tabs defaultTab="administrative">
        <TabsList>
          <Tab id="administrative">{t('tabs.administrative')}</Tab>
          <Tab id="teaching">{t('tabs.teaching')}</Tab>
        </TabsList>
        <TabPanels>
          <TabPanel id="administrative">
            <Form>
              <FormProvider {...methodsAdmin}>
                <CourseAdministrativeTab />
              </FormProvider>
            </Form>
          </TabPanel>
          <TabPanel id="teaching">
            <Form>
              <FormProvider {...methodsTeaching}>
                <CourseTeachingTab />
              </FormProvider>
            </Form>
          </TabPanel>
        </TabPanels>
      </Tabs>
      <CourseFooterSection />
    </>
  );
};

export default CourseForm;
